<template>
    <el-dialog class="create-team-vops-div dialog-body-wrap zimbra-dialog zimbra-limited-width-dialog"
               :title="$t('zimbra.zmMsg.roomVOpsTitle')"
               :visible.sync="visible" width="640px"
               :append-to-body="true" :close-on-click-modal="false" >
        <perfect-scrollbar style="max-height: 500px; padding-left: 16px; padding-right: 16px" v-loading="dialogLoading">
            <div @click="handleClickGroupVops(groupId)" v-if="isExistGroup" style="text-align: center">
                <h3 class="font-weight-bold">{{$t('zimbraNokey.existVopsGroup')}} </h3>
                <span class="font-italic title-exist-vops">{{ `${CONFIG?.ENDPOINT?.vOpsService}/group/${groupId}` }} </span>
            </div>
            <el-form v-else class="form-wrap form-wrap-ct" ref="formCreateVOps" :model="form" :rules="rules"
                     label-position="top">
                <!--            <div class="row-ct">-->
                <el-form-item class="el-form-item-ct" prop="name">
                    <span class="label-item-ct required">
                        {{ $t("zimbra.zmMsg.roomVOpsName") }}
                        <span class="required-ct">*</span>
                    </span>
                    <el-input v-model="form.name" autocomplete="off" size="small" class="el-text-control"
                              :placeholder="$t('zimbra.zmMsg.roomVOpsNamePlaceholder')"
                              @change="changeNewName"></el-input>
                </el-form-item>

                <!--            </div>-->
                <!--            detai-->
                <el-form-item class="el-form-item-ct" prop="topic">
                    <span class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsTopic") }}</span>
                    <el-input v-model="form.topic" autocomplete="off" size="small" class="el-text-control"
                              :placeholder="$t('zimbra.zmMsg.roomVOpsTopicPlaceholder')"
                              @change="changeNewName"></el-input>
                    <span class="label-item-ct sub">{{ $t("zimbra.zmMsg.roomVOpsTopicSub") }}</span>
                </el-form-item>
                <!--            ng tham gia nhom-->
                <div class="d-flex flex-column" style="gap: 24px">
                    <el-form-item class="el-form-item-ct el-form-item-ct-search" prop="topic">
                        <span class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsMember") }}</span>
                        <div>
                            <el-dropdown
                                trigger="click"
                                placement="bottom-start"
                                teleported="false"
                                style="position: relative; width: 100%"
                                @visible-change="handleDropdownVisible"
                                class="zimbra-dialog"
                                ref="dropdownRef"
                            >
                                <el-input v-model="form.memberSearch" autocomplete="off" size="small"
                                          class="el-text-control"
                                          :placeholder="$t('zimbra.zmMsg.roomVOpsMemberPlaceholder')"
                                          @change="changeNewName"
                                          @input="onSearchInputMember"
                                          @keyup.enter.native="onEnterSearchMember"

                                >
                                    <SearchIcon slot="prefix" :type="'df16'" />
                                </el-input>
                                <el-dropdown-menu slot="dropdown" class="dropdown-menu-ct">
                                    <div class="d-flex flex-column" style="width: 100%;">
                                        <perfect-scrollbar class="w-100" style="max-height: 200px">
                                            <div class="d-flex flex-column w-100 dropdown-ct" style="gap: 16px">
                                                <div v-for="item in lstUserJoin" :key="item.key"
                                                     class="d-flex flex-column w-100" @click.prevent="changeItemSelected({...item, selected: !item?.selected})">
                                                    <div class="d-flex justify-content-between card-item-ct">
                                                        <div class="left-item-ct d-flex align-items-center"
                                                             style="gap: 8px">
                                                            <BaseAvatar :listEmailAddress="[item]" :size-avt="'20px'"
                                                                        :margin-top="'0'" />
                                                            <div class="d-flex align-items-center" style="gap: 8px">
                                                                <span>{{ item?.username }}</span>
                                                                <DotIcon />
                                                                <span>{{ item?.a }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="right-item-ct">
                                                            <el-checkbox v-model="item.selected"
                                                                         :disabled="item?.a === optionF?.a"
                                                                         @change.prevent="changeItemSelected({...item, selected: !item?.selected})"><span
                                                                class="check-box-text"></span></el-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </perfect-scrollbar>
                                        <div class="footer-dropdown-ct">
                                            <div class="d-flex justify-content-end" style="gap: 8px">
                                                <el-button class="btn-email-ct default" @click="handleClearDropdown">
                                                    {{ $t("zimbra.zmMsg.roomVOpsDropdownClear") }}
                                                </el-button>
                                                <el-button type="primary"
                                                           @click="handleSubmitDropdown()">
                                                    {{ $t("zimbra.zmMsg.roomVOpsDropdownSubmit") }}
                                                </el-button>
                                            </div>
                                        </div>

                                    </div>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>


                    </el-form-item>
                    <div class="item-selected-ct d-flex flex-wrap align-items-end" style="gap: 16px">
                        <div v-for="avt in form.memberSelected" :key="avt.a">
                            <BaseAvatar :listEmailAddress="[avt]" :size-avt="'40px'" :margin-top="'0'" :show-popover="true">
                                <template v-slot:iconDelete>
                                    <div class="icon-trans-df" @click="handleClearChose(avt, 'lst')"
                                         v-if="avt?.a !== optionF?.a">
                                        <CloseTransIcon />
                                    </div>
                                </template>
                                <template v-slot:iconDeleteCt>
                                    <div class="icon-trans-df" style="position: absolute; top: 0; right: 0"
                                         @click="handleClearChose(avt, 'lst')" v-if="avt?.a !== optionF?.a">
                                        <CloseTransIcon />
                                    </div>
                                </template>
                            </BaseAvatar>
                        </div>
                    </div>
                </div>

                <!--            <div class="row-ct">-->
                <!--                <span>{{ $t("zimbraNokey.zimbra_sidebar_dialogReNameTag_tagName") }}</span>-->
                <!--                <el-input v-model="newName" autocomplete="off" size="small" class="el-text-control"-->
                <!--                    @change="changeNewName"></el-input>-->
                <!--            </div>-->
                <div class="d-flex justify-content-between ">
                    <div class="d-flex flex-column" style="gap: 4px;">
                        <div class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsType") }}</div>
                        <div class="label-item-ct-v1 sub">{{ $t("zimbra.zmMsg.roomVOpsTypeSub") }}</div>
                    </div>
                    <div>
                        <el-form-item>
                            <el-switch style="display: block" v-model="form.type" :active-value="1" :inactive-value="0"
                                       class="switch-ct"></el-switch>
                        </el-form-item>
                    </div>
                </div>
                <div class="d-flex flex-column" style="gap: 16px;">
                    <div class="d-flex" style="gap: 6px;">
                        <a style="display: flex" class="zm-calendar-more-details align-items-center" href="javascript:;" @click="isOpen = !isOpen">
                        <span>{{ `${isOpen ? $t("zimbra.zmMsg.roomVOpsOptionAdvanceHidden") : $t("zimbra.zmMsg.roomVOpsOptionAdvance")}`
                            }}</span>
                            <ChevronIcon :type="isOpen ? 'up' : 'down'" />
                        </a>
                        <!--                <span>{{ // $t("zimbraNokey.zimbra_sidebar_dialogReNameTag_tagName") }}</span> <ChevronIcon :type="isOpen ? 'up' : 'down'"/>-->
                    </div>
                    <div v-if="isOpen" class="d-flex flex-column" style="gap: 16px;">
                        <!--                    ma hoa-->
                        <div class="d-flex justify-content-between ">
                            <div class="d-flex flex-column" style="gap: 4px;">
                                <div class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsEncrypted") }}</div>
                                <div class="label-item-ct-v1 sub">{{ $t("zimbra.zmMsg.roomVOpsEncryptedSub") }}</div>
                            </div>
                            <div>
                                <el-form-item>
                                    <el-switch style="display: block" v-model="form.encrypted" :disabled="true"
                                               :active-value="true"
                                               :inactive-value="false" class="switch-ct"></el-switch>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between ">
                            <div class="d-flex flex-column" style="gap: 4px;">
                                <div class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsReadOnly") }}</div>
                                <div class="label-item-ct-v1 sub">{{ $t("zimbra.zmMsg.roomVOpsReadOnlySub") }}</div>
                            </div>
                            <div>
                                <el-form-item>
                                    <el-switch style="display: block" v-model="form.readOnly" :active-value="true"
                                               :inactive-value="false" class="switch-ct"></el-switch>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between ">
                            <div class="d-flex flex-column" style="gap: 4px;">
                                <div class="label-item-ct">{{ $t("zimbra.zmMsg.roomVOpsBroadcast") }}</div>
                                <div class="label-item-ct-v1 sub">{{ $t("zimbra.zmMsg.roomVOpsBroadcastSub") }}</div>
                            </div>
                            <div>
                                <el-form-item>
                                    <el-switch style="display: block" v-model="form.broadcast" :active-value="true"
                                               :inactive-value="false" class="switch-ct"></el-switch>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </perfect-scrollbar>

        <div slot="footer" class="dialog-footer">
            <div class="d-flex justify-content-end" style="gap: 8px">
                <el-button  @click="visible = false">{{ $t("zimbra.zmMsg.roomVOpsCancel") }}</el-button>
                <el-button v-if="!isExistGroup" :loading="dialogLoading" type="primary" @click="handleSubmit()">{{ $t("zimbra.zmMsg.roomVOpsSubmit") }}</el-button>
                <el-button v-else type="primary" @click="handleClickGroupVops(groupId)">{{ $t("zimbra.zmMsg.access_vops") }}</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import ZimbraMailService from "@/services/ZimbraMailService.js";
import CommonUtils from "@/utils/common-utils";
import { mapGetters } from "vuex";
import { STATUS_REQUEST, READ_EMAIL_LAYOUT_ROUTER } from "@/utils/constants";
import _ from "lodash";
import ChevronIcon from "../../../../assets/icons/ChevronIcon.vue";
import SearchIcon from "../../../../assets/icons/SearchIcon.vue";
import BaseAvatar from "@/components/modules/base/base-avatar/base-avatar.vue";
import DotIcon from "@/assets/icons/DotIcon.vue";
import CloseTransIcon from "@/assets/icons/CloseTransIcon.vue";
import VOpsService from "@/services/VOpsService";
import CONFIG from "@/config/config";
import html2canvas from "html2canvas";

export default {
    components: { SearchIcon, ChevronIcon, BaseAvatar, DotIcon, CloseTransIcon },
    mixins: [CommonUtils],
    computed: {
        CONFIG() {
            return CONFIG
        },
        ...mapGetters(["tags", "listTag"]),
        lstUserJoin() {
            const selectedSet = new Set(
                (this.form.memberSelected || [])
                    .map(u => u.a)
                    .filter(k => k != null)
            );

            const dataSelectedKey = Array.isArray(this.lstUserJoinSelected) ? this.lstUserJoinSelected.map((i) => i?.a).filter(Boolean) : [];

            const mergeArr = this.lstUserAjustCompleteDropdown
                .filter((e) => !this.form.memberSelected?.map((sl) =>sl.a)?.includes(e.a))
                .concat(
                this.lstUserJoinMap?.filter((e) => !this.form.memberSearch || e?.a.toLowerCase().includes(this.form.memberSearch?.toLowerCase())),
                this.form.memberSelected?.filter((e) => (!this.form.memberSearch || e?.a.toLowerCase().includes(this.form.memberSearch?.toLowerCase())) ) // && (i?.is)
                ).filter(item => !!item).map((item, index) => {
                item.key = index;
                return item;
            });
            const seen = new Set();
            const uniques = [];

            for (const it of mergeArr) {
                const k = it?.a; // so sánh không phân biệt hoa/thường
                if (k == null || seen.has(k)) continue;

                seen.add(k);
                // KHÔNG mutate item gốc; clone ra và gán key
                const clone = { ...it, selected: selectedSet.has(k) || !!it.selected };
                uniques.push(clone);
            }

            return uniques.map((it, idx) => ({
                ...it,
                key: idx,
                selected: it?.a === this.optionF?.a || (dataSelectedKey?.length > 0 ? dataSelectedKey.includes(it?.a) : false)
            }));
        }
    },
    mounted() {
        this.$root.$on("handleCreateVops", (data) => {
            this.show(data);
        });

    },
    beforeDestroy() {
        this.$root.$off("handleCreateVops");
    },
    destroyed() {
        this.reloadForm();
    },
    data() {
        return {
            treeNodeData: {},
            newName: "",
            labelPosition: "top",
            form: {
                name: null, //ten nhom
                topic: null, //de tai
                memberSearch: null, //ng tham gia nhom
                memberSelected: null, //ng tham gia nhom
                member: [], //ng tham gia nhom
                type: 1,
                encrypted: false,
                readOnly: false,
                broadcast: false
            },
            rules: {
                name: [
                    { required: true, message: this.$t("zimbra.zmMsg.msgValidNameRequiredVops"), trigger: "change" }
                    // { pattern: /^[0-9a-zA-ZÀ-ỹ\-_. ]+$/, message: this.$t("zimbra.zmMsg.msgValidNameTeamVops") }
                ]
            },
            visible: false,
            fileImageCut: null,
            isOpen: false,
            elementImage: null,
            elementFile: null,
            elementFileCapcut: null,
            optionF: {},
            lstUserJoinOriginal: [],
            lstUserJoinMap: [],
            lstUserJoinSelected: [],
            lstUserAjustCompleteDropdown: [],
            mailId: null,
            _debouncedSearch: null,
            dialogLoading: false,
            isExistGroup: false,
            groupId: "",

        };
    },
    created() {
        this._debouncedSearch = this._debounce(async (q) => {
            await this.fetchUsers(q);
        }, 300);
    },
    watch:{
        visible(val){
            if (val === false)
            setTimeout(()=>{
                this.isExistGroup = false;
                this.groupId = ""
            }, 1000)
        }
    },
    methods: {
        show(data) {
            this.reloadForm(data);
            this.treeNodeData = data;
            this.optionF = data?.optionF ?? {};
            this.elementFileCapcut = data?.element;
            this.mailId = data?.mailData?.m?.mid;
            this.lstUserJoinOriginal = Array.isArray(data?.lstUserJoin) ? data?.lstUserJoin : [data?.optionF];
            this.lstUserJoinSelected = this.lstUserJoinOriginal;
            this.form.memberSelected = _.clone(this.lstUserJoinSelected);
            this.reMapLstUserJoin(this.lstUserJoinSelected);
            this.newName = this.treeNodeData.name;
            this.visible = true;
            // // Cách first focus input
            // $(document).ready(function() {
            //     setTimeout(function() {
            //         const divMainContract = $(".create-team-vops-div");
            //         const firstInput = $(":input:not(input[type=button],input[type=submit],button):visible:first", divMainContract);
            //         firstInput.focus();
            //     }, 500);
            // });
            const { name } = this.$route;
            if (name == READ_EMAIL_LAYOUT_ROUTER.NAME_HIDE) {
                this.isMessage = true;
            } else {
                this.isMessage = false;
            }
        },
        reloadForm(data) {
            this.form = {
                name: data?.subjectDf ?? undefined, //ten nhom
                topic: null, //de tai
                memberSearch: null, //ng tham gia nhom
                memberSelected: null, //ng tham gia nhom
                member: [], //ng tham gia nhom
                type: 1,
                encrypted: false,
                readOnly: false,
                broadcast: false
            };
            this.isOpen = false;
        },
        reNameTag() {
            this.newName = this.newName.toString().trim();
            if (
                this.newName === "" ||
                this.newName.length > 128 ||
                this.newName.indexOf("/") > -1
            ) {
                const nameError = _.escape(this.newName);
                const Msgerror =
                    this.newName === ""
                        ? this.$t("zimbra.zmMsg.nameEmpty")
                        : this.newName.length > 128
                            ? this.$t("zimbra.zhMsg.nameTooLong", { 0: 128 })
                            : this.$t(
                                "zimbra.zmMsg.errorInvalidName",
                                { 0: nameError }
                            );
                this.$alert(Msgerror, this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"), {
                    confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                    customClass: "notification-error-tag",
                    type: "error"
                });
                return;
            }
            if (this.newName.toLowerCase() != this.treeNodeData.name.toString().toLowerCase()) {
                if (this.checkExistsName(this.newName)) {
                    return;
                }
            }
            const newName = _.escape(this.newName);
            const form = {
                tag: `<urn1:action id="${this.treeNodeData.id}" op="rename" name="${newName}"></urn1:action>`
            };
            ZimbraMailService.tagActionRequest(form).then((res) => {
                if (res.status == STATUS_REQUEST.SUCCESS) {
                    if (this.isMessage) {
                        this.$message({
                            type: "success",
                            customClass: "zm-notify",
                            duration: 3500,
                            dangerouslyUseHTMLString: true,
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessReNameTag")
                        });
                    } else {
                        this.$notify({
                            title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessReNameTag"),
                            type: "success"
                        });
                    }
                }
                this.tags.name = this.newName;
                this.$store.commit("SET_TAGS", this.tags);
            });
            this.visible = false;
        },
        changeNewName() {
            console.log("form.memberSearch", this.form.memberSearch);
            this.newName = this.newName ? this.newName.trim() : "";
        },
        checkExistsName(name) {
            if (this.listTag) {
                if (this.listTag.map(x => x.name.toString().toLowerCase()).indexOf(name.toString().toLowerCase()) > -1) {
                    this.$alert(
                        this.$t("zimbra.zmMsg.tagNameExists", {
                            name: name
                        }),
                        this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        {
                            confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error"
                        }
                    );
                    return true;
                }
            }
        },
        handleClose() {
            this.visible = false;
        },
         downloadBlob(blob, filename = 'capture.png') {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Fallback cho Safari iOS (không hỗ trợ download attr)
    if (typeof a.download === 'undefined') {
        window.open(url, '_blank');
    } else {
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    setTimeout(() => URL.revokeObjectURL(url), 1000);
},
        handleClickGroupVops(groupId){
            window.open(`${CONFIG?.ENDPOINT?.vOpsService}/group/${groupId}`, "_blank");
        },
        handleSubmit() {
            this.$refs["formCreateVOps"].validate((valid) => {
                if (!valid) return;
                const jsonBody = {
                    name: this.form.name,
                    members: this.form.memberSelected?.flatMap(x => x?.a ? [x.a] : []),
                    type: this.form.type,
                    workGroup: false,
                    room: {
                        readOnly: this.form.readOnly,
                        extraData: {
                            topic: this.form.topic,
                            broadcast: this.form.broadcast,
                            encrypted: this.form.encrypted
                        }
                    },
                    emailId: this.mailId,
                    vmailCall: 1
                };
                const members = this.form.memberSelected?.flatMap(x => x?.a ? [x.a] : []);
                const jsonValid = {
                    message: JSON.stringify({
                        msg: "method",
                        id: "",
                        method: "validMember",
                        params: [members]
                    })
                };
                this.dialogLoading= true;
                VOpsService.validMemberVops(jsonValid)
                    .then(res => {
                        this.dialogLoading= false;
                        const memberRq = JSON.parse(res?.data?.message);
                        if (memberRq?.result?.error) {
                            const memberArr = Array.isArray(memberRq?.result?.members) ? memberRq?.result?.members : [];
                            if (memberArr && memberArr?.length < 2) {
                                this.$notify({
                                    title: this.$t("zimbra.zmMsg.ALT_ERROR"),
                                    message: this.$t("zimbra.zmMsg.msgErrorNotEnoughtEmailExist"),
                                    type: "error"
                                });
                            } else {
                                if (memberArr?.length !== this.form.memberSelected?.length) {
                                    this.$notify({
                                        title: this.$t("zimbra.zmMsg.ALT_ERROR"),
                                        message: this.$t("zimbra.zmMsg.errorMsgValidMember"),
                                        type: "error"
                                    });
                                    jsonBody.members = memberArr.map((item) => item?.username);
                                    this.createRoomVops(jsonBody);
                                } else {
                                    this.$notify({
                                        title: this.$t("zimbra.zmMsg.ALT_ERROR"),
                                        message: memberRq?.result?.reason?.includes("memberNotExistVOps") ? this.$t("zimbra.zmMsg.errorMsgValidMember") : memberRq?.error?.reason,
                                        type: "error"
                                    });
                                }
                            }
                        } else {
                            const memberArr = Array.isArray(memberRq?.result?.members) ? memberRq?.result?.members : [];
                            jsonBody.members = memberArr.map((item) => item?.username);
                            this.createRoomVops(jsonBody);
                        }
                    })
                    .catch(err => {
                        this.dialogLoading= false;
                        console.log("err", err);
                        this.$notify({
                            title: "Lỗi",
                            message: err?.message || err,
                            type: "error"
                        });
                    });

            });
        },
        async createRoomVops(jsonBody) {
            this.dialogLoading = true;
            const jsonFindTeamChatByEmailIdVOps = {
                message: JSON.stringify({
                    msg: "method",
                    id: "",
                    method: "findTeamChatByEmailId",
                    params: [jsonBody.emailId]
                })
            };
            VOpsService.findTeamChatByEmailIdVOps(jsonFindTeamChatByEmailIdVOps)
                .then((response) => {
                    if (response?.data?.success) {
                        const rs = JSON.parse(response.data?.message);
                        if (rs?.error?.error) {
                            this.$notify({
                                title: this.$t('zimbra.zmMsg.ALT_ERROR'),
                                message: rs?.error?.reason ?? '',
                                type: "error"
                            });
                            return;
                        }
                        if (rs?.result) {
                            this.isExistGroup = true
                            this.groupId = rs.result?.roomId || ""
                            this.$notify({
                                title: this.$t('zimbra.zmMsg.ALT_ERROR'),
                                message: this.$t('zimbra.zmMsg.errorTeamCreateExistValid'),
                                type: "error"
                            });
                        } else {
                            this.createRoomVopsSubmit(jsonBody);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.dialogLoading = false;
                })
        },
        createRoomVopsSubmit(jsonBody) {
            this.dialogLoading= true;
            VOpsService.createTeamVOps(jsonBody)
                .then( async (res) => {
                    if (res?.status === 200 && res.data) {
                        this.$notify({ //dataSourceTestSuccess
                            title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                            message: this.$t("zimbra.zmMsg.msgCreateTeamVopsSuccess"),
                            type: "success"
                        });
                        this.handleClose();
                        this.exportElementToBlob()
                            .then((blob) => {
                                const MAX_SIZE = 10 * 1024 * 1024;
                                if (blob.size > MAX_SIZE) {
                                    this.$notify({
                                        title: 'Lỗi',
                                        message: 'Ảnh chia sẻ nội dung mail vượt quá kích thước tối đa 10MB.',
                                        type: 'error',
                                    });
                                    this.dialogLoading = false;
                                    return
                                }
                                
                                const data = res.data;
                                const roomId = data?.team?.roomId;
                                const formData = new FormData();    // Nếu là object
                                const safeName = (jsonBody.name || 'cap_cut')
                                        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '')  // loại ký tự cấm
                                        .trim()                                 // bỏ khoảng trắng đầu/ cuối
                                        || 'cap_cut';
                                formData.append("file", new File([blob], `${safeName}.png`, { type: "image/png" }));
                                VOpsService.roomUploadVOps(formData, roomId)
                                    .then((res) => {
                                        if (res?.data?.success) {
                                            if (CONFIG?.ENDPOINT?.vOpsService) {
                                                window.open(`${CONFIG?.ENDPOINT?.vOpsService}/group/${res?.data?.message?.rid}`, "_blank");
                                            }
                                        }
                                    });
                            })
                    } else if (!res?.data?.success && res?.data?.error) {
                        this.$notify({
                            title: this.$t("zimbra.zmMsg.ALT_ERROR"),
                            message: res?.data?.error?.includes("team-name-already-exists") ? this.$t("zimbra.zmMsg.msgValidNameExistTeamVops", [(jsonBody?.name || "")]) : res?.data?.error,
                            type: "error"
                        });
                    }
                })
                .catch((err) => {
                    console.log("error", err);
                    this.$notify({
                        title: this.$t("zimbra.zmMsg.ALT_ERROR"),
                        message: err?.message?.includes("team-name-already-exists") ? this.$t("zimbra.zmMsg.errorMsgValidMember") : err?.message,
                        type: "error"
                    });
                })
                .finally(() => {
                    this.dialogLoading = false;
                });
        },
        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            for (let i = 0; i < n; i++) {
                u8arr[i] = bstr.charCodeAt(i);
            }

            return new Blob([u8arr], { type: mime });
        },
        handleSubmitDropdown() {
            this.form.memberSelected = _.clone(this.lstUserJoinSelected);
            this.onEnterSearchMember();
            this.$refs.dropdownRef?.hide();
            this.form.memberSearch = "";
        },
        handleClearDropdown() {
            this.lstUserJoinSelected = [this.optionF];
            this.form.memberSelected = _.clone(this.lstUserJoinSelected);
            this.reMapLstUserJoin(this.form.memberSelected);
            this.$refs.dropdownRef?.hide();
            this.form.memberSearch = "";
        },
        // reMapLstUserJoin(arrData) {
        //     if (Array.isArray(arrData) && arrData?.length > 0) {
        //         this.lstUserJoinSelected = _.clone(arrData);
        //     }
        //     const grouped = {};
        //     const dataSelectedKey = Array.isArray(arrData) ? arrData.map((i) => i.a).filter(i => i) : [];
        //     let arrRs = [];
        //
        //     this.lstUserJoinOriginal.forEach(user => {
        //         const firstLetter = user?.a?.charAt(0).toUpperCase(); // lấy chữ cái đầu
        //         if (!grouped[firstLetter]) {
        //             grouped[firstLetter] = [];
        //         }
        //         user.selected = user?.a === this.optionF?.a || (dataSelectedKey?.length > 0 ? dataSelectedKey.includes(user?.a) : false);
        //         grouped[firstLetter].push(user);
        //     });
        //     for (const property in grouped) {
        //         arrRs.push({
        //             key: property,
        //             value: grouped[property]
        //         });
        //     }
        //     this.lstUserJoinMap = arrRs;
        // },
        reMapLstUserJoin(arrData) {
            if (Array.isArray(arrData) && arrData?.length > 0) {
                this.lstUserJoinSelected = _.clone(arrData);
            }
            const dataSelectedKey = Array.isArray(arrData) ? arrData.map((i) => i?.a).filter(Boolean) : [];

            this.lstUserJoinMap = this.lstUserJoinOriginal.map((user) => {
                user.selected = user?.a === this.optionF?.a || (dataSelectedKey?.length > 0 ? dataSelectedKey.includes(user?.a) : false);
                user.key = user?.a;
                return user;
            });
        },

        onSearchInputMember(val) {
            const q = (val || "").trim();
            if (!q) {
                // this.lstUserJoinMap = [];
                // this.closeDropdown();
                return;
            }
            // luôn mở dropdown khi người dùng gõ
            // this.openDropdown();
            // debounce gọi API
            this._debouncedSearch(q);
        },
        _debounce(fn, wait = 300) {
            let t = null;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        },
        handleDropdownVisible(visible) {
            if (visible) {
                this.lstUserAjustCompleteDropdown = [];
                this.reMapLstUserJoin(this.form.memberSelected);
            } else {
                this.onEnterSearchMember();
            }
        },
        async fetchUsers(query) {
            const formData = {
                name: this.form.memberSearch
            };
            this.lstUserAjustCompleteDropdown = [];
            ZimbraMailService.autoCompleteRequest(
                formData
            ).then(searchRequest => {
                this.showLoading = false;
                let { match } =
                this.getResponseBody(searchRequest)["AutoCompleteResponse"] || {};
                match = Array.isArray(match) ? match : (match ? [match] : []);
                this.lstUserAjustCompleteDropdown = match
                    ? match.map((e) => {
                        return {
                            ...e,
                            text: e.email || e.display || this.$t("zimbra.zhMsg.noName"),
                            p: e.full || e.first,
                            a: this.getAddressEmailFromText(e.email || ""),
                            showExpand: true
                        };
                    })
                        .filter(e =>
                            !this.tags.map(t => t.a).includes(e.a)
                        )
                    : [];
            }).catch(() => {
                this.showLoading = false;
            });
        },
        onEnterSearchMember() {
            let listText = (this.form.memberSearch || "").split(" ");
            const firstText = listText[0];
            console.log(listText);
            if (listText && listText.length > 1) {
                for (let text of listText) {
                    if (this.form.memberSelected.some(tag => tag.a === text)) {
                        continue;
                    }
                    if (this.validateEmail(text)) {
                        this.form.memberSelected.push({
                            a: text,
                            username: text,
                            isText: true,
                            isSelected: true
                        });
                    }
                }
            } else {
                if (firstText && this.validateEmail(firstText)) {
                    if (this.form.memberSelected.some(tag => tag.a === firstText)) {
                        return false;
                    }
                    this.form.memberSelected.push({
                        a: firstText,
                        username: firstText,
                        isText: true,
                        isSelected: true
                    });
                }
            }
            this.form.memberSearch = "";
        },
        changeItemSelected(data, typeReload) {
            console.log('checked running ', data);
            const idx = typeReload === "lst" ? this.form.memberSelected.findIndex(x => x.a === data.a) : this.lstUserJoinSelected.findIndex(x => x.a === data.a);
            if (data?.selected) {
                if (idx < 0) (typeReload === "lst" ? this.form.memberSelected.push(data) : this.lstUserJoinSelected.push(data));
            } else {
                if (idx >= 0) (typeReload === "lst" ? this.form.memberSelected.splice(idx, 1) : this.lstUserJoinSelected.splice(idx, 1));
            }
            if (typeReload === "drop") this.reMapLstUserJoin(this.lstUserJoinSelected);
        },
        handleClearChose(item, typeReload) {
            this.changeItemSelected({ ...item, selected: false }, typeReload);
        },
        async toDataURL(url) {
            const res = await fetch(url, { mode: "cors" }); // nếu server cho phép CORS
            const blob = await res.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result); // base64 dataURL
                reader.readAsDataURL(blob);
            });
        },
        dataUrlSvgToString(dataUrl) {
            const prefix = 'data:image/svg+xml;base64,';
            if (!dataUrl.startsWith(prefix)) throw new Error('Không đúng định dạng SVG base64');
            const b64 = dataUrl.slice(prefix.length);

            // Giải mã base64 → bytes → UTF-8 string (an toàn với ký tự Unicode)
            const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
            const svgText = new TextDecoder('utf-8').decode(bytes);
            return svgText; // đây chính là nội dung <svg>...</svg>
        },
        async renderImgAsDataUrl(url) {
            const res = await fetch(url, { credentials: "include" });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        async exportElementToBlob() {
            const element = document.getElementById('mail-detail-form-htmlCa-detail');
            if (!element) throw new Error("Không tìm thấy element");
            const iframe = element.querySelector("iframe");
            const htmlString = iframe?.getAttribute("srcdoc") || element.innerHTML;
            // Parse DOM ảo
            const doc = new DOMParser().parseFromString(htmlString, "text/html");
            // Cache để tránh convert lại ảnh trùng nhau
            const imgCache = new Map();

            // Lấy danh sách ảnh
            const imgEls = doc.querySelectorAll("img");

            for (const img of imgEls) {
                const src = img.getAttribute("dfsrc") || img.getAttribute("src");
                if (!src || src.startsWith("data:")) continue;

                try {
                    if (imgCache.has(src)) {
                        img.setAttribute("src", imgCache.get(src));
                        continue;
                    }

                    const base64 = await this.renderImgAsDataUrl(src);
                    img.setAttribute("src", base64);
                    imgCache.set(src, base64);

                } catch (err) {
                    console.warn("Image convert failed:", src, err);
                }
            }

            const finalHtml = doc.documentElement.outerHTML;
            return await this.exportHtmlStringToImage(finalHtml);
        },

        async exportHtmlStringToImage(htmlString) {

            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.left = "-9999px";
            iframe.style.top = "-9999px";
            iframe.style.opacity = "0";
            iframe.style.width = "1400px";
            iframe.style.border = "none";
            document.body.appendChild(iframe);

            return new Promise(resolve => {
                iframe.onload = async () => {
                    const doc = iframe.contentDocument || iframe.contentWindow.document;

                    try {
                        const element = doc.body;

                        const canvas = await html2canvas(element, {
                            scale: window.devicePixelRatio,
                            useCORS: true,
                            allowTaint: true,
                            backgroundColor: "#fff"
                        });

                        canvas.toBlob(blob => {
                            resolve(blob);
                            iframe.remove();
                        }, "image/png");

                    } catch (e) {
                        console.error("Export failed:", e);
                        iframe.remove();
                    }
                };

                iframe.srcdoc = htmlString;
            });
        },
    }
};
</script>
<style scoped lang="scss">
.row-ct {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.form-wrap-ct {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.dropdown-menu-ct {
    max-width: 608px;
    width: 608px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    box-shadow: 0px 4px 6px -2px rgba(26, 26, 26, 0.20);
}

.dropdown-ct {
    gap: 16px;
    padding: 12px 16px;
}

.card-item-ct {
    padding: 6px 0;
    cursor: pointer;
}

.right-item-ct {
    display: flex;
    align-items: center;
    justify-content: end;

    .el-checkbox {
        width: 14px;
        height: 14px;
    }

    .el-checkbox__input {
        line-height: unset !important;
    }
}

.item-selected-ct {

}

.icon-trans-df {
    cursor: pointer;
    float: right;
    margin-right: -8px;
    margin-top: -6px;
}

.footer-dropdown-ct {
    height: 56px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: end;
    border-top: 1px solid #DEE2E6;

    .el-button--primary {
        background-color: var(--color-primary) !important;
    }

    .el-button:hover {
        box-shadow: rgb(0 0 0 / 20%) 0px 2px 14px;
    }

}

::v-deep {
    .el-dialog__header {
        height: 56px;
        padding: 12px 16px !important;
        color: var(--Neutral-900, #212529);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            color: #212529;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
        }
    }

    .el-dialog__headerbtn {
        font-size: 20px !important;
        position: unset !important;
    }

    .el-dialog__body {
        padding: 16px 0 !important;
    }

    .el-dialog__footer {
        padding: 12px 16px !important;
    }

    .el-form-item-ct .el-input__inner {
        padding: 6px 12px !important;
        color: #313131;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .el-form-item-ct-search .el-input__inner {
        padding: 6px 12px 6px 28px !important;
        color: #313131;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .el-form-item-ct-search .el-input__inner::placeholder {
        overflow: hidden;
        color: #A7A7A7;
        text-overflow: ellipsis;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px !important; /* 142.857% */
    }

    .el-form-item-ct-search {
        .el-input__prefix {
            left: 12px;
            top: 6px;
        }
    }


    .switch-ct {
        .el-switch__core {
            //border-radius: 6px;
            //width: 32px !important;
        }
    }

    .el-switch.is-checked .el-switch__core {
        background-color: #EE0033 !important;
        border-color: #EE0033 !important;
    }

    .form-wrap .el-form-item {
        margin-bottom: 0 !important;
    }

    .form-wrap .el-form-item__label {
        line-height: 20px !important;
        padding: 0 !important;
    }

    .form-wrap .el-form-item__content {
        width: 100% !important;
    }

    .form-wrap .el-form-item__error {
        margin-left: 0px !important;
    }

    .el-button {
        display: flex;
        height: 32px;
        padding: 6px 12px;
        justify-content: center;
        align-items: center;
        align-self: stretch;

        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;

        border-radius: 8px;
        border: none;
        margin: 0;
    }

    .zm-avatar .user-avt-character,
    .zm-avatar .zm-avatar img {
        width: var(--sizeAvt);
        height: var(--sizeAvt);
        border-radius: 8px;
        margin-top: var(--marginTop);
    }

    //check box
    .el-checkbox__input .el-checkbox__inner {
        background: white;
        border: 1px solid #A7A7A7 !important;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
        box-shadow: none !important;
    }

    .el-checkbox__input.is-disabled .el-checkbox__inner {
        background-color: #edf2fc !important;
        border-color: #DCDFE6 !important;
        cursor: not-allowed;
    }

}
.title-exist-vops:hover{
    color: var(--color-primary);
    cursor: pointer;
}
</style>

